import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import {
  Backdrop,
  Box,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { useGetTokenOrLogout } from "../../../utils/token";
import { useNavigate } from "react-router-dom";
import PackagesFilter from "./PackagesFilter";

import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import CustomPopup from "../../../components/CustomPopup";
import AllBranches from "../Campaign/AllBranches";

import EditTestPrepPackage from "./EditTestPrepPackage";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import DescriptionPopup from "./DescriptionPopup";
import VeiwIcon from "../../newComponent/iconsComp/VeiwIcon";
import ViewTestPrepPackageDetails from "./ViewTestPrepPackageDetails";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const DescriptionCell = ({ description }) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!description) return <div>-</div>;

  const shouldTruncate = description.length > 50;

  return (
    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
      {expanded
        ? description
        : shouldTruncate
          ? description.slice(0, 50) + "..."
          : description}

      {shouldTruncate && (
        <span
          onClick={() => setExpanded((prev) => !prev)}
          style={{ color: "#1976d2", cursor: "pointer", marginLeft: "5px" }}
        >
          {expanded ? "See less" : "See more"}
        </span>
      )}
    </div>
  );
};

export default function TestPrepPackages({ open, serviceId }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [isEditFormOpen, setEditFormOpen] = useState(false);

  const [searchData, setSearchData] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState(null);
  const [originalData, setOriginalData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [branchPopup, setBranchpopup] = useState(false);
  const [subServvicePopup, setSubservicePopup] = useState(false);
  const [selectedbranhes, setseletedbranches] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isDeleteFormOpen, setIsDeleteFormOpen] = useState(false);
  const [packageToDelete, setPackageToDelete] = useState(null);
  const [descriptionPopupOpen, setDescriptionPopupOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [openView, setOpenView] = useState(false);

  const handleDeleteOpenPopup = (pkg) => {
    setPackageToDelete(pkg);
    setIsDeleteFormOpen(true);
  };

  const handleDeleteClosePopup = () => {
    setIsDeleteFormOpen(false);
    setPackageToDelete(null);
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpenForm = (packageData) => {
    setSelectedRowData(packageData);
    setEditFormOpen(true);
  };

  const handleCloseForm = () => {
    setSelectedRowData(null);
    setEditFormOpen(false);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        user_id: parseInt(userId),
        service_id: serviceId,
      };
      const response = await fetch(`${API_ENDPOINT}route2.0/getpackages`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });
      const result = await response.json();

      if (response.ok) {
        const sortedData = result.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        setPackages(sortedData);
        setOriginalData(sortedData);
        setSearchData(sortedData);
        setIsLoading(false);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
      } else if (response.status === 401) {
        showSnackbar(result.message, "error");
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
      } else {
        showSnackbar("Internal server error", "error");
        setIsLoading(false);
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleSubmit();
  }, [serviceId]);

  const handleDeletePackage = async () => {
    if (!packageToDelete) return;

    const token = getTokenOrLogout();
    if (!token) return;

    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        user_id: parseInt(userId),
        package_id: packageToDelete?.id,
        is_active: false,
        status: "inActive",
      };

      const response = await fetch(
        `${API_ENDPOINT}package/update/updatepackage`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        },
      );

      const result = await response.json();

      if (response.ok) {
        // remove deleted package from state without reload
        setPackages((prev) =>
          prev.filter((pkg) => pkg.id !== packageToDelete.id),
        );
        setSearchData((prev) =>
          prev.filter((pkg) => pkg.id !== packageToDelete.id),
        );
        setOriginalData((prev) =>
          prev.filter((pkg) => pkg.id !== packageToDelete.id),
        );

        showSnackbar("Package deleted successfully", "success");
        handleDeleteClosePopup();
      } else {
        showSnackbar(result.message || "Failed to delete package", "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };

  const openbranchpopup = (branches) => {
    setBranchpopup(true);
    setseletedbranches(branches);
  };

  const closeBranchpopup = () => {
    setBranchpopup(false);
    setseletedbranches([]);
    // setGridKey((prevKey) => prevKey + 1)
  };

  const openServicePopup = (services) => {
    setSubservicePopup(true);
    setseletedbranches(services);
  };

  const closeServicepopup = () => {
    setSubservicePopup(false);
    setseletedbranches([]);
    // setGridKey((prevKey) => prevKey + 1)
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      width: 80,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "0.1rem", alignItems: "center" }}>
          {userRole === "center_admin" && (
            <>
              <IconButton
                style={{ color: "#00b13f" }}
                size="small"
                aria-label="edit"
                onClick={() => handleOpenForm(params?.row)}
              >
                <Tooltip title="Edit">
                  <EditIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                </Tooltip>
              </IconButton>

              <VeiwIcon
                fontSize="0.9rem"
                onClick={() => handleOpenView(params.row)}
                tooltipTitle="View"
              />

              <IconButton
                style={{ color: "#b10000ff" }}
                size="small"
                aria-label="delete"
                onClick={() => handleDeleteOpenPopup(params?.row)}
              >
                <Tooltip title="Delete">
                  <DeleteIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                </Tooltip>
              </IconButton>
            </>
          )}
        </div>
      ),
    },
    {
      field: "package_name",
      headerName: "Package Name",
      width: 250,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.package_name}</div>,
    },

    {
      field: "service",
      headerName: "Service",
      width: 250,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.service_id?.service_name || "",
      renderCell: (params) => <div>{params?.row.service_id?.service_name}</div>,
    },

    {
      field: "sub_service",
      headerName: "Sub Service",
      width: 250,
      headerClassName: "header-cell",
      sortable: false, // Enable sorting
      disableColumnMenu: true,
      renderCell: (params) => {
        const services = params?.row?.sub_service_id || [];
        const visibleCount = 1; // Set the number of visible Service
        const visibleService = services.slice(0, visibleCount);
        const extraService = services.slice(visibleCount);

        return (
          <>
            {visibleService.map((services, index) => (
              <div key={index}>{services}</div>
            ))}
            {extraService.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() => openServicePopup(extraService)}
              >
                {`+${extraService.length}`}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration(in session)",
      width: 100,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.duration}</div>,
    },
    {
      field: "test_type",
      headerName: "Test Type",
      width: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.test_type?.name || "",
      renderCell: (params) => <div>{params?.row.test_type?.name}</div>,
    },

    {
      field: "sub_test_type",
      headerName: "Sub Test Type",
      width: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.sub_test_type_id?.name || "",
      renderCell: (params) => <div>{params?.row.sub_test_type_id?.name}</div>,
    },

    {
      field: "country_id",
      headerName: "Country",
      width: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.country_id?.country_name || "",
      renderCell: (params) => <div>{params?.row.country_id?.country_name}</div>,
    },

    {
      field: "currency",
      headerName: "Currency",
      width: 120,
      headerClassName: "header-cell",
    },

    {
      field: "branch",
      headerName: "Branch",
      width: 150,
      sortable: false, // Enable sorting
      disableColumnMenu: true,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.branch_id.join(", ") || "",
      // renderCell: (params) => <div>{params?.row.branch_id.join(", ")}</div>,
      renderCell: (params) => {
        const branches = params?.row?.branch_id || [];
        const visibleCount = 1; // Set the number of visible branches
        const visiblebranch = branches.slice(0, visibleCount);
        const extrabranch = branches.slice(visibleCount);

        return (
          <>
            {visiblebranch.map((branches, index) => (
              <div key={index}>{branches}</div>
            ))}
            {extrabranch.length > 0 && (
              <Typography
                variant="h6"
                style={{
                  cursor: "pointer",
                  marginLeft: "7px",
                  color: "#46b1ff",
                }}
                onClick={() => openbranchpopup(extrabranch)}
              >
                {`+${extrabranch.length}`}
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "original_price",
      headerName: "Original Price",

      headerClassName: "header-cell",

      renderCell: (params) => <div>{params?.row.original_price}</div>,
    },
    {
      field: "discounted_price",
      headerName: "Discounted Price",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.discounted_price}</div>,
    },

    {
      field: "payable_installment",
      headerName: "Payable Installments",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.payable_installment}</div>,
    },
    {
      field: "max_allow_day",
      headerName: "Max Allowable Days",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.max_allow_day}</div>,
    },
    {
      field: "description",
      headerName: "Description",
      width: 300,
      headerClassName: "header-cell",
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const description = params?.row?.description || "";

        if (!description) return <div>-</div>;

        const shouldTruncate = description.length > 30;

        return (
          <div>
            {shouldTruncate ? description.slice(0, 30) + "..." : description}
            {shouldTruncate && (
              <span
                style={{
                  color: "#1976d2",
                  cursor: "pointer",
                  marginLeft: "5px",
                }}
                onClick={() => {
                  setSelectedDescription(description);
                  setDescriptionPopupOpen(true);
                }}
              >
                See more
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "Is Testiva Map",
      headerName: "Is Testiva Package",

      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>{params?.row.is_testiva_map === 1 ? "Yes" : "No"}</div>
      ),
    },
    {
      field: "Testiva Package Name",
      headerName: "Testiva Package Name",

      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.testiva_package_id?.name}</div>,
    },
    // {
    //   field: "mock_tests",
    //   headerName: "Mock Tests",
    //   width: 70,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div>{params?.row.mock_tests}</div>,
    // },

    // {
    //   field: "module_wise_questions",
    //   headerName: "Module-Wise Tests",
    //   width: 70,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div>{params?.row.module_wise_questions}</div>,
    // },

    // {
    //   field: "question_wise_questions",
    //   headerName: "Question-Wise Tests",
    //   width: 70,
    //   headerClassName: "header-cell",
    //   renderCell: (params) => <div> {params?.row.question_wise_questions}</div>,
    // },

    {
      field: "status",
      headerName: "Status",
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row.status === "active" && (
            <Chip
              variant="contained"
              label="Active"
              size="small"
              color="secondary"
            />
          )}
          {params?.row.status === "inActive" && (
            <Chip
              variant="contained"
              label="Inactive"
              size="small"
              color="error"
            />
          )}
        </div>
      ),
    },
  ];

  // search all column in datagrid
  const handleNameChange = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data.package_name}`,
        `${data.service_id?.service_name || ""}`,
        `${data.sub_service_id || ""}`,
        `${data.duration}`,
        `${data.test_type?.name}`,
        `${data.sub_test_type_id?.name}`,
        `${data?.branch_id}`,
        `${data?.original_price}`,
        `${data?.discounted_price}`,
        `${data?.payable_installment}`,
        `${data?.max_allow_day}`,
        `${data?.mock_tests}`,

        `${data?.module_wise_questions}`,
        `${data?.question_wise_questions}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value),
      );
    });

    setPackages(filteredData1); // Update the filtered data
  };

  const handleApplyFilter = (criteria) => {
    setFilterCriteria(criteria);
  };
  const handleResetFilter = () => {
    setFilterCriteria(null);
    setPackages(originalData);
    setSearchData(originalData);
  };

  const handleOpenView = (row) => {
    setSelectedRowData(row);
    window.open(`/view-packages-details/${row?.id}`, "_blank");
  };

  const handleCloseView = () => {
    setOpenView(false);
  };
  return (
    <>
      <LoaderComp isLoading={isLoading} />

      <Grid container spacing={2}>
        {/* filter */}
        {open && (
          <Grid item xs={12}>
            <PackagesFilter
              open={open}
              packageData={packages}
              searchData={searchData}
              originalData={originalData}
              setPackages={setPackages}
              setSearchData={setSearchData}
              showSnackbar={showSnackbar}
              serviceId={serviceId}
              setIsLoading={setIsLoading}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <SearchTextFieldComp
                    size="small"
                    onChange={handleNameChange}
                    InputProps={{
                      style: { borderRadius: "15px" }, // Add borderRadius here
                    }}
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                {/* table */}
                <DataGrid
                  rows={packages}
                  columns={columns}
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={branchPopup}
        onClose={closeBranchpopup}
        component={
          <AllBranches
            onClose={closeBranchpopup}
            selectedbranhes={selectedbranhes}
          />
        }
        title="Branches"
        showDivider="true"
        maxWidth="xs"
      />

      <CustomPopup
        open={subServvicePopup}
        onClose={closeServicepopup}
        component={
          <AllBranches
            onClose={closeServicepopup}
            selectedbranhes={selectedbranhes}
          />
        }
        title="Sub Services"
        showDivider="true"
        maxWidth="xs"
      />

      <CustomPopup
        open={isEditFormOpen}
        onClose={handleCloseForm}
        component={
          <EditTestPrepPackage
            onClose={handleCloseForm}
            rowData={selectedRowData}
            setSelectedRowData={setSelectedRowData}
          />
        }
        title="Edit Package"
        showDivider="true"
        maxWidth="md"
      />

      <ConfirmationPopup
        open={isDeleteFormOpen}
        onClose={handleDeleteClosePopup}
        title="Delete Package Confirmation"
        textBody={`Are you sure you want to delete the package "${packageToDelete?.package_name}"?`}
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleDeletePackage}
      />

      <DescriptionPopup
        open={descriptionPopupOpen}
        description={selectedDescription}
        onClose={() => setDescriptionPopupOpen(false)}
      />

      <CustomPopup
        open={openView}
        onClose={handleCloseView}
        component={
          <ViewTestPrepPackageDetails
            onClose={handleCloseView}
            rowData={selectedRowData}
          />
        }
        title="View Package Details"
        showDivider="true"
        maxWidth="md"
      />
    </>
  );
}
